import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageUrlPipe } from '../ui/images/image-url.pipe';
import { UserScoreDisplayComponent } from './user-score-display.component';



@NgModule({
  declarations: [UserScoreDisplayComponent],
  exports: [UserScoreDisplayComponent],
  imports: [
    CommonModule,
    ImageUrlPipe,
  ]
})
export class UserScoreDisplayModule { }
